module.exports = __webpack_public_path__ + "static/media/SOTA NOVA VII.61834d8c.png";